import { ref, onMounted } from 'vue'
import { trackAddHomescreenSuccess } from '@/assets/js/addHomescreenAnalytics'

const deferredPrompt = ref(null)
const isInstalled = ref(false)
const isIOS = ref(false)
/** iPhone（不含 iPad、iPod 可按需排除；当前仅将 Phone 与 Pad 分开） */
const isIPhone = ref(false)
export function usePWA() {
  // 检测安装状态
  const checkInstallStatus = () => {
    // 1. 检查是否在独立窗口运行 (Android/Chrome/iOS)
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches
    // 2. 针对旧版 iOS Safari 的检查
    const isIOSStandalone = window.navigator.standalone === true

    isInstalled.value = isStandalone || isIOSStandalone
    isIOS.value = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
    const ua = typeof navigator !== 'undefined' ? navigator.userAgent : ''
    isIPhone.value = /iPhone/.test(ua)

    logger.debug('isInstalled:', isInstalled.value)
    logger.debug('isStandalone:', window.matchMedia('(display-mode: standalone)').matches)
  }

  // 触发安装
  const triggerInstall = async () => {
    logger.debug('enter triggerInstall')
    if (isIOS.value) {
      // iOS 无法通过代码触发，返回特定状态告知组件显示引导图层
      logger.debug('enter triggerInstall, ios')
      return 'IOS_GUIDE'
    }

    logger.debug('enter triggerInstall, deferredPrompt = ', deferredPrompt.value)
    if (!deferredPrompt.value) {
      logger.debug('enter triggerInstall, deferredPrompt is null')
      return 'NOT_AVAILABLE'
    }

    logger.debug('enter triggerInstall, prompt')
    // 执行原生安装提示
    deferredPrompt.value.prompt()
    const { outcome } = await deferredPrompt.value.userChoice
    logger.debug('enter triggerInstall, finish')
    // 执行完后清空，因为该事件只能使用一次
    deferredPrompt.value = null
    return outcome // 'accepted' 或 'dismissed'
  }

  onMounted(() => {
    checkInstallStatus()

    if (!window.hasPWAListener) {
      // 监听浏览器的安装提示事件
      window.addEventListener('beforeinstallprompt', (e) => {
        logger.debug('beforeinstallprompt = ', e)
        e.preventDefault() // 阻止默认的自动弹窗
        deferredPrompt.value = e // 保存事件
      })

      // 监听安装完成事件
      window.addEventListener('appinstalled', () => {
        isInstalled.value = true
        deferredPrompt.value = null
        trackAddHomescreenSuccess({ result: 'appinstalled' })
        logger.debug('PWA installed successfully')
      })
      window.hasPWAListener = true
    }
  })

  return {
    isInstalled,
    isIOS,
    isIPhone,
    canInstall: deferredPrompt,
    triggerInstall
  }
}
